import { Locales } from "../enums/locales";
export const localeFieldKeys = ["en", "fr", "es", "de"];
export const localeToLocaleFieldKey = {
    [Locales.EN]: "en",
    [Locales.FR]: "fr",
    [Locales.ES]: "es",
    [Locales.DE]: "de",
};
export const localeFieldKeyToLocale = {
    en: Locales.EN,
    fr: Locales.FR,
    es: Locales.ES,
    de: Locales.DE,
};
export const getDefinedLocaleFieldEntries = (fields) => localeFieldKeys.flatMap((key) => {
    const value = fields[key];
    return value === undefined ? [] : [{ locale: localeFieldKeyToLocale[key], value }];
});
export const hasAnyLocaleField = (fields) => localeFieldKeys.some((key) => fields[key] !== undefined);
export const trimLocaleFields = (fields) => {
    const trimmed = {};
    for (const key of localeFieldKeys) {
        const value = fields[key];
        if (value !== undefined) {
            trimmed[key] = value.trim();
        }
    }
    return trimmed;
};
export const getNonEmptyLocaleFields = (fields) => {
    const nonEmpty = {};
    for (const key of localeFieldKeys) {
        const value = fields[key]?.trim();
        if (value) {
            nonEmpty[key] = value;
        }
    }
    return nonEmpty;
};
const LOCALE_TO_CATEGORY_NAME_LABEL_KEY = {
    [Locales.EN]: "ticketing.categories.modal.nameEnglish",
    [Locales.FR]: "ticketing.categories.modal.nameFrench",
    [Locales.ES]: "ticketing.categories.modal.nameSpanish",
    [Locales.DE]: "ticketing.categories.modal.nameGerman",
};
export const categoryNameLabelKeyForLocale = (locale) => LOCALE_TO_CATEGORY_NAME_LABEL_KEY[locale];
